import el from "@cypherpotato/el";

const TOTAL_DIGITS = 14;

export function LoginKeyInput(options = {}) {
    const { onChange, onComplete, onCreate } = options;

    const container = el("div.login-key-input", {
        $functions: {
            getValue() {
                const inputs = this.querySelectorAll("input.login-key-digit");
                return Array.from(inputs).map(i => i.value).join("");
            },
            setValue(value) {
                const inputs = this.querySelectorAll("input.login-key-digit");
                const chars = value.replace(/[^a-zA-Z0-9]/g, "").slice(0, TOTAL_DIGITS).split("");
                inputs.forEach((input, i) => {
                    input.value = chars[i] || "";
                });
                if (chars.length === TOTAL_DIGITS) {
                    inputs[TOTAL_DIGITS - 1].focus();
                    this.notifyComplete();
                } else if (chars.length > 0) {
                    inputs[Math.min(chars.length, TOTAL_DIGITS - 1)].focus();
                }
            },
            notifyComplete() {
                if (onComplete) {
                    onComplete(this.getValue());
                }
            },
            notifyChange() {
                if (onChange) {
                    onChange(this.getValue());
                }
            }
        },
        init() {
            if (onCreate)
                onCreate(this);

            for (let i = 0; i < TOTAL_DIGITS; i++) {
                const isFirst = i === 0;

                const input = el("input.login-key-digit", {
                    type: isFirst ? "password" : "text",
                    maxlength: isFirst ? TOTAL_DIGITS : 1,
                    autocomplete: isFirst ? "current-password" : "off",
                    "aria-label": isFirst ? "Login key" : `Login key character ${i + 1}`,
                    autofocus: isFirst,
                    inputmode: "text",
                    name: isFirst ? "loginKey" : undefined,
                    "data-index": i,

                    onInput(e) {
                        if (isFirst && this.value.length > 1) {
                            container.setValue(this.value);
                            container.notifyChange();
                        }
                    },

                    onKeyDown(e) {
                        const index = parseInt(this.dataset.index);
                        const inputs = container.querySelectorAll("input.login-key-digit");

                        if (e.key === "Backspace") {
                            if (this.value === "" && index > 0) {
                                inputs[index - 1].focus();
                                inputs[index - 1].select();
                            }
                            return;
                        }

                        if (e.key === "ArrowLeft" && index > 0) {
                            e.preventDefault();
                            inputs[index - 1].focus();
                            inputs[index - 1].select();
                            return;
                        }

                        if (e.key === "ArrowRight" && index < TOTAL_DIGITS - 1) {
                            e.preventDefault();
                            inputs[index + 1].focus();
                            inputs[index + 1].select();
                            return;
                        }

                        if (e.key.length === 1 && /[a-zA-Z0-9]/.test(e.key) && !e.ctrlKey && !e.metaKey) {
                            e.preventDefault();
                            this.value = e.key;
                            container.notifyChange();

                            if (index < TOTAL_DIGITS - 1) {
                                inputs[index + 1].focus();
                                inputs[index + 1].select();
                            } else {
                                container.notifyComplete();
                            }
                        }
                    },

                    onPaste(e) {
                        e.preventDefault();
                        const pastedData = (e.clipboardData || window.clipboardData).getData("text");
                        const cleanData = pastedData.replace(/[^a-zA-Z0-9]/g, "");
                        container.setValue(cleanData);
                        container.notifyChange();
                    },

                    onFocus() {
                        this.select();
                    }
                });

                this.appendChild(input);
            }
        }
    });

    return container;
}

